export default "__VITE_ASSET__c3qyhrXR__"